<template>
  <div>
    <Modal v-model="resetPasswordModal" title="确认" @on-ok="verifyResetPassword">
      <p>你确定要重置{{ selectUser && selectUser.name }}的密码吗？</p>
    </Modal>
    <Modal v-model="changeDepartmentModal" title="设置员工关联部门" @on-ok="submitChangeDepartment">
      <Tree :data="selectTreeDepartmentData" show-checkbox @on-check-change="selectChangeDepart"></Tree>
    </Modal>
    <Modal v-model="changeFactoryModal" title="设置员工关联工厂" @on-ok="submitChangeFactory">
      <CheckboxGroup v-model="selectFactoryData">
        <Checkbox v-for="item in factoryList" :key="item._id" :label="item._id">{{ item.name }}</Checkbox>
      </CheckboxGroup>
    </Modal>
    <Modal v-model="changePasswordModal" title="修改用户密码" @on-ok="submitChangePassword('changePasswordForm')" width="300">
      <Form ref="changePasswordForm" :model="changePasswordForm" :rules="changePasswordValidate">
        <FormItem label="请输入新密码" prop="newPassword">
          <Input v-model="changePasswordForm.newPassword" placeholder="新密码"></Input>
        </FormItem>
      </Form>
    </Modal>
    <Modal v-model="bannedUserModal" :title="banned ? '恢复用户' : '禁用用户'" @on-ok="submitBannedUser()" width="300">
      <div>确认是否{{ banned ? "恢复" : "禁用" }}此用户</div>
    </Modal>
    <Tabs value="name1" :animated="false" style="height: 100%">
      <TabPane label="部门与员工" name="name1">
        <Row style="height: 100%">
          <Col span="6" class="department-panel">
          <div class="handle-wrapper">
            <h1 style="margin-right: auto">部门</h1>
            <Button type="primary" @click="openEditDepartmentDrawer()" style="margin-right: 15px">新增部门</Button>
            <!-- <Button v-if="selectedDepart" @click="openEditDepartmentDrawer(selectedDepart)">编辑部门</Button> -->
          </div>
          <Input search placeholder="搜索部门" style="margin-bottom: 8px" />
          <Tree :data="treeDepartmentData" show-checkbox @on-check-change="selectChange" :render="renderContent"></Tree>
          </Col>
          <Col span="18" class="user-panel">
          <div class="userlist-wrapper">
            <!-- <h1 style="margin-right: auto">{{selectedDepart ? selectedDepart.name : '全部'}}</h1> -->
            <div class="selectBar">
              <Input v-model="searchUserText" search placeholder="搜索用户..." @on-change="searchUser" clearable
                icon="ios-search" style="width: 250px; margin-right: 30px"></Input>
              <Select placeholder="筛选角色" v-model="selectRole" label-in-value multiple @on-change="choseRole"
                style="width: 220px; margin-right: 30px">
                <Option v-for="item in roleList" :value="item.value" :key="item.value">{{ item.label }}</Option>
              </Select>
              <Checkbox @on-change="searchUser" v-model="selectSuperAdmin">超级管理员</Checkbox>
              <Checkbox @on-change="searchUser" v-model="selectBannedUser">禁用用户</Checkbox>
            </div>
            <div class="funBar">
              <span>共{{ totalRows }}条</span>
              <Page :total="totalRows" :page-size="20" @on-change="loadUser" show-total simple
                style="margin-right: 24px" />
              <Button type="primary" style="margin-right: 24px" @click="$refs.UploadFileModal.openModal()"
                v-if="currentUser.superAdmin">导入员工</Button>
              <Button type="primary" @click="$refs.CreateUserDrawer.openDrawer()">创建员工</Button>
            </div>
          </div>
          <div class="table-wrapper" ref="tableWrapper">
            <Table :columns="columns" :data="tableData" size="small" :height="tableHeight">
              <template v-if="
                currentUser.superAdmin ||
                arrayIntersection(['hr'], currentUser.simpleRole).length > 0
              " slot-scope="{ row }" slot="status">
                <Dropdown trigger="hover" @on-click="clickActionDropDown" transfer>
                  <a>
                    操作
                    <Icon type="ios-arrow-down"></Icon>
                  </a>
                  <DropdownMenu slot="list">
                    <!-- <div v-if="row.initialPassword">
                        <DropdownItem :name="`I ${row._id}`">查看初始密码</DropdownItem>
                      </div>-->
                    <div>
                      <!-- <DropdownItem :name="`R ${row._id}`" disabled>重置密码</DropdownItem> -->
                      <DropdownItem :name="`D ${row._id}`">设置关联部门</DropdownItem>
                      <DropdownItem :name="`F ${row._id}`">设置关联工厂</DropdownItem>
                      <div v-if="currentUser.superAdmin">
                        <DropdownItem :name="`P ${row._id}`">修改密码</DropdownItem>
                      </div>
                      <div v-if="currentUser.superAdmin">
                        <DropdownItem :name="`R ${row._id}`">重置密码</DropdownItem>
                      </div>
                      <div v-if="currentUser.superAdmin">
                        <DropdownItem style="color: #ed4014" :name="`B ${row._id}`">
                          {{
                            row.banned ? "恢复用户" : "禁用用户"
                          }}
                        </DropdownItem>
                      </div>
                    </div>
                  </DropdownMenu>
                </Dropdown>
              </template>
            </Table>
          </div>
          </Col>
        </Row>
      </TabPane>
    </Tabs>
    <EditDepartmentDrawer ref="EditDepartmentDrawer" />
    <InviteUserDrawer ref="InviteUserDrawer" />
    <UploadFileModal ref="UploadFileModal" @uploadSuccess="loadUser" />
    <CreateUserDrawer ref="CreateUserDrawer" @editSuccess="loadUser" :selectedDepart="selectedDepart" />
  </div>
</template>



<script>
import { mapState, mapActions, mapGetters } from "vuex";
import EditDepartmentDrawer from "./EditDepartmentDrawer";
import InviteUserDrawer from "./InviteUserDrawer";
import CreateUserDrawer from "./CreateUserDrawer";
import UploadFileModal from "./UploadFileModal.vue";
import { arrayIntersection } from "@/utils";

const simpleRoleToText = {
  sales: "业务人员",
  hr: "人事",
  salesLead: "业务经理",
  salesAssist: "业务助理",
  productionWorkers: "生产工人",
  technologyLead: "技术服务经理",
  technology: "技术服务人员",
  purchase: "采购",
  driver: "司机",
  factoryLeader: "厂长",
  allFactoryLeader: "总厂长",
  deliveryAssist: "跟单助理",
  deliveryLeader: "运输部主管",
  none: "无",
  acct: "财务",
  acctManager: "财务总监",
  purchaseLead: "采购经理",
  ywf: "业务费",
  semiRecipe: "查看修改母液"
};

export default {
  name: "UserManagement",
  components: {
    EditDepartmentDrawer,
    InviteUserDrawer,
    CreateUserDrawer,
    UploadFileModal
  },
  data() {
    const validtNewPassword = (rule, value, cb) => {
      const reg = /^(?=.*[a-zA-Z])(?=.*\d)[^]{8,20}$/;
      if (!reg.test(value)) {
        cb(new Error("密码必须由数字和字母组成"));
      } else {
        cb();
      }
    };
    return {
      resetPasswordModal: false,
      selectFactoryData: [],
      tableHeight: 300,
      changeFactoryModal: false,
      treeDepartmentData: [],
      selectTreeDepartmentData: [],
      changeDepartmentValue: null,
      changeDepartmentModal: false,
      changePasswordModal: false,
      bannedUserModal: false,
      selectUser: null,
      banned: null,
      page: 0,
      openEditRoleDrawer: false,
      openedUser: null,
      openedDepartment: null,
      selectedDepart: null,
      searchUserText: "",
      userFilterQuery: { limit: 20 },
      selectSuperAdmin: false,
      selectBannedUser: false,
      selectRole: null,
      selectedRole: {
        _id: null
      },
      columns: [
        {
          title: "名字",
          key: "name",
          width: 140,
          render: (h, params) => {
            return h("div", [
              h(
                "h4",
                {
                  props: {
                    type: "text",
                    size: "small"
                  },
                  style: {
                    color: "#42b983",
                    cursor: "pointer"
                  },
                  on: {
                    click: () => {
                      this.openedUser = params.row;
                      this.$refs.CreateUserDrawer.openDrawer(params.row);
                    }
                  }
                },
                params.row.name
              )
            ]);
          }
        },
        {
          title: "手机",
          key: "mobile",
          render: (h, params) => h("span", params.row.mobile)
        },
        {
          title: "角色",
          key: "role",
          render: (h, params) => {
            if (params.row.superAdmin) return h("span", "超级管理员");
            // return h("span", simpleRoleToText[params.row.simpleRole]);
            return h(
              "span",
              params.row.simpleRole
                .map(x => (x = simpleRoleToText[x]))
                .join(",")
            );
          }
        },
        {
          title: "企业微信",
          key: "weworkUserId",
          render: (h, params) => h("span", params.row.weworkUserId)
        },
        {
          title: "关联部门",
          key: "department",
          render: (h, params) => {
            return h(
              "span",
              params.row.department ? params.row.department.name : ""
            );
          }
        },
        {
          title: "关联工厂",
          key: "factoryRole",
          render: (h, params) => {
            const str = params.row.factoryRole
              ? params.row.factoryRole.map(x => x.name).join(", ")
              : "";
            return h("span", str);
          }
        },
        {
          title: "销售成本可见公司",
          key: "salesCalcCostVisibleCompany",
          render: (h, params) => {
            const str = params.row.salesCalcCostVisibleCompany
              ? params.row.salesCalcCostVisibleCompany.map(x => x.name).join(", ")
              : "";
            return h("span", str);
          }
        },
        {
          title: "是否初始密码",
          key: "initPassword",
          align: "center",
          width: 150,
          render: (h, params) => {
            const initPassword = params.row.initialPassword ? "是" : "";
            if (this.currentUser.superAdmin) return h("span", initPassword);
          }
        },
        {
          title: "状态",
          key: "status",
          slot: "status",
          width: 90
        },
        {
          title: "是否被禁用",
          key: "banned",
          align: "center",
          width: 100,
          render: (h, params) => {
            const initPassword = params.row.banned ? "是" : "";
            if (this.currentUser.superAdmin)
              return h(
                "span",
                {
                  style: {
                    color: "#ed4014"
                  }
                },
                initPassword
              );
          }
        }
      ],
      changePasswordValidate: {
        newPassword: [
          { required: true, message: "请填写新密码", trigger: "blur" },
          {
            type: "string",
            min: 8,
            message: "密码必须大于8位数",
            trigger: "blur"
          },
          {
            validator: validtNewPassword,
            trigger: "blur"
          }
        ]
      },
      changePasswordForm: {
        newPassword: ""
      },
      roleList: [
        {
          value: "sales",
          label: "业务人员"
        },
        {
          value: "hr",
          label: "人事"
        },
        {
          value: "salesLead",
          label: "业务经理"
        },
        {
          value: "salesAssist",
          label: "业务助理"
        },
        {
          value: "productionWorkers",
          label: "生产工人"
        },
        {
          value: "technologyLead",
          label: "技术服务经理"
        },
        {
          value: "technology",
          label: "技术服务人员"
        },
        {
          value: "purchase",
          label: "采购"
        },
        {
          value: "driver",
          label: "司机"
        },
        {
          value: "factoryLeader",
          label: "厂长"
        },
        {
          value: "allFactoryLeader",
          label: "总厂长"
        },
        {
          value: "deliveryAssist",
          label: "跟单助理"
        },
        {
          value: "deliveryLeader",
          label: "运输部主管"
        },
        {
          value: "acct",
          label: "财务"
        },
        {
          value: "acctManager",
          label: "财务总监"
        },
        {
          value: "ywf",
          label: "业务费"
        },
        {
          value: "semiRecipe",
          label: "查看修改母液"
        }
      ]
    };
  },
  computed: {
    ...mapState({
      tableData: state => state.user.userList,
      totalRows: state => state.user.totalCounts,
      currentUser: state => state.auth.currentUser,
      departmentList: state => state.department.departmentList,
      factoryList: state => state.factory.factoryList
    }),
    ...mapGetters({
      getUserById: "user/getUserById",
      getTreeDepartment: "department/getTreeDepartment",
      getTreeSelectDepartment: "department/getTreeSelectDepartment"
    })
  },
  methods: {
    arrayIntersection(array, targetArray) {
      return arrayIntersection(array, targetArray);
    },
    submitChangeFactory() {
      this.updateUser({
        id: this.selectUser,
        data: { factoryRole: this.selectFactoryData }
      });
    },
    ...mapActions({
      getDepartmentList: "department/getDepartmentListAction",
      createDepartment: "department/createDepartmentAction",
      updateUser: "user/updateUserAction",
      getUserList: "user/getUsersAction",
      bannedUser: "user/bannedUserAction",
      recoverUser: "user/recoverAction",
      adminChangeUserPassword: "user/adminChangeUserPasswordAction",
      getFactorys: "factory/getFactorysAction",
      adminResetUserPassword: "user/adminResetUserPasswordAction",
      getCompanyList: "company/getCompanyListAction"
    }),
    renderContent(h, { root, node, data }) {
      let button;
      let textStyle = {
        style: {
          display: "flex",
          width: "100%",
          alignItems: "center"
        }
      };
      button = h(
        "span",
        {
          style: {
            display: "inline-block",
            float: "right",
            marginLeft: "10px"
          }
        },
        [
          h("Button", {
            props: Object.assign({}, this.buttonProps, {
              icon: "md-create"
            }),
            style: {
              padding: "0 4px",
              height: "24px"
            },
            on: {
              click: () => {
                this.openEditDepartmentDrawer(data);
              }
            }
          })
        ]
      );
      let content;
      if (data._id) {
        content = h("span", textStyle, [h("span", data.title), button]);
      } else {
        content = h("span", textStyle, [h("span", data.title)]);
      }
      return content;
    },
    selectChangeDepart(arr, obj) {
      arr.forEach(item => {
        item.checked = false;
      });
      obj.checked = true;
      this.changeDepartmentValue = obj._id;
    },
    async submitChangeDepartment() {
      try {
        await this.updateUser({
          id: this.selectUser,
          data: { department: this.changeDepartmentValue }
        });
      } catch (error) {
        this.$Message.error(error);
      }
      this.$Message.success("关联成功");
      this.selectedDepart = this.departmentList.find(
        x => x._id === this.changeDepartmentValue
      );
      this.treeDepartmentData = this.getTreeSelectDepartment(false, [
        this.changeDepartmentValue
      ]);
      this.getUserList({
        department: this.selectedDepart._id,
        showCount: true,
        showInitialPassword: true
      });
    },

    // 修改密码提交
    async submitChangePassword(name) {
      this.$refs[name].validate(async valid => {
        if (valid) {
          await this.adminChangeUserPassword({
            id: this.selectUser,
            password: this.changePasswordForm.newPassword
          });
          this.changePasswordForm.newPassword = "";
          this.$Message.success("修改成功!");
        } else {
          this.$Message.error("修改失败!");
        }
      });
    },
    // 禁用和恢复用户
    async submitBannedUser() {
      const id = this.selectUser;
      if (this.banned) {
        try {
          await this.recoverUser({ id });
          this.$Message.success("恢复成功");
        } catch (error) {
          this.$Message.error(error);
        }
      } else {
        try {
          await this.bannedUser({ id });
          this.$Message.success("禁用成功");
        } catch (error) {
          this.$Message.error(error);
        }
      }
    },
    selectChange(arr, obj) {
      let departmentList = [];
      for (let i = 0; i < arr.length; i++) {
        if (arr[i]._id) departmentList.push(arr[i]._id);
      }
      this.selectedDepart = obj;
      if (departmentList.length > 0) {
        this.getUserList({
          departmentArray: { $in: departmentList },
          showCount: true,
          showInitialPassword: true
        });
      } else {
        this.getUserList({ showCount: true, showInitialPassword: true });
      }
    },
    append(data) {
      const children = data.children || [];
      children.push({
        title: "appended node",
        expand: true
      });
      this.$set(data, "children", children);
    },
    remove(root, node, data) {
      const parentKey = root.find(el => el === node).parent;
      const parent = root.find(el => el.nodeKey === parentKey).node;
      const index = parent.children.indexOf(data);
      parent.children.splice(index, 1);
    },
    openEditDepartmentDrawer(data) {
      this.$refs.EditDepartmentDrawer.openDrawer(data, this.treeDepartmentData);
    },
    openInviteUserDrawer() {
      this.$refs.InviteUserDrawer.openDrawer();
    },
    async clickActionDropDown(name) {
      const actionCode = name.slice(0, 1);
      const user = await this.getUserById(name.slice(2));
      switch (actionCode) {
        case "I": // 查看初始密码
          // this.showInitialPasswordModal(user);
          break;
        case "D": // 选择关联部门
          this.selectUser = user._id;
          this.changeDepartmentModal = true;
          if (user.department && user.department._id) {
            this.selectTreeDepartmentData = this.getTreeSelectDepartment(true, [
              user.department._id
            ]);
          } else {
            this.selectTreeDepartmentData = this.getTreeSelectDepartment(true);
          }
          if (user.department && user.department._id)
            this.changeDepartmentValue = user.department._id;
          break;
        case "P":
          this.selectUser = user._id;
          this.changePasswordModal = true;
          break;
        case "B":
          this.banned = user.banned;
          this.selectUser = user._id;
          this.bannedUserModal = true;
          break;
        case "F":
          this.selectUser = user._id;
          this.changeFactoryModal = true;
          this.selectFactoryData = user.factoryRole
            ? user.factoryRole.map(x => x._id)
            : [];
          break;
        case "R":
          this.selectUser = user;
          this.resetPasswordModal = true;
          break;
        default:
          break;
      }
    },
    async verifyResetPassword() {
      const data = await this.adminResetUserPassword(this.selectUser._id);
      this.showInitialPasswordModal(data);
    },
    showInitialPasswordModal(user) {
      this.$Modal.info({
        title: `用户：${user.name}`,
        content: `<p>手机号：${user.mobile}</p> <p>初始密码：${user.initialPassword}</p>`
      });
    },
    async loadUser(page) {
      if (page) this.page = page - 1;
      this.filterQuery = {
        ...this.filterQuery,
        skip: this.page * 20,
        showCount: true,
        showInitialPassword: true
      };
      if (this.searchUserText && this.searchUserText.trim() !== "") {
        this.filterQuery.userName = this.searchUserText;
      } else {
        delete this.filterQuery.userName;
      }
      if (this.selectSuperAdmin) {
        this.filterQuery.superAdmin = this.selectSuperAdmin;
      } else {
        delete this.filterQuery.superAdmin;
      }
      if (this.selectBannedUser) {
        this.filterQuery.banned = this.selectBannedUser;
      } else {
        delete this.filterQuery.banned;
      }

      try {
        this.tableLoading = true;
        await this.getUserList(this.filterQuery);
        this.tableLoading = false;
      } catch (error) {
        this.$Message.error(`加载失败: ${error}`);
        this.tableLoading = false;
      }
    },
    searchRole() {
      this.page = 0;
      this.loadRole();
    },
    searchUser() {
      this.page = 0;
      this.loadUser();
    },
    choseRole(e) {
      if (e.length > 0) {
        const simpleRole = e.map(x => x.value).join(",");
        this.filterQuery.simpleRole = simpleRole;
      } else {
        delete this.filterQuery.simpleRole;
      }
      this.loadUser();
    }
  },
  async created() {
    this.page = 0;
    this.loadUser();
    await this.getDepartmentList();
    await this.getFactorys();
    await this.getCompanyList({ limit: 99 });
    this.treeDepartmentData = this.getTreeDepartment();
  },
  mounted() {
    this.tableHeight = this.$refs.tableWrapper.offsetHeight;
    window.onresize = () => {
      this.tableHeight = this.$refs.tableWrapper.offsetHeight;
    };
  },
  destroyed() {
    window.onresize = null;
  }
};
</script>

<style scoped lang="stylus">
.ivu-tabs-content
  height 100% !important

.department-panel
  height 100%
  padding 0 16px
  -webkit-user-select none /* Safari */
  -moz-user-select none /* Firefox */
  -ms-user-select none /* IE10+/Edge */
  user-select none /* Standard */

.user-panel
  padding-left 16px
  height 100%
  overflow-y auto

.role-panel
  padding 16px
  border 1px solid #dcdee2
  border-radius 4px
  // overflow-y: auto;
  height calc(100% - 20px)

.handle-wrapper
  width 100%
  height 48px
  display flex
  align-items center
  justify-content flex-end

.userlist-wrapper
  width 100%
  height 48px
  display flex
  align-items center
  justify-content space-between

  .funBar
    display flex
    align-items center
    justify-content flex-end

.table-wrapper
  width 100%
  height calc(100% - 48px)

.role-item
  width 100%
  height 32px
  line-height 32px
  padding 0 8px
  cursor pointer

  &:hover
    color #0168fa
    border 1px solid #0168fa
    box-shadow 0 2px 4px rgba(209, 230, 220, 1)
    transition 0.2s

.role-item-active
  color #0168fa
  border 1px solid #0168fa
  box-shadow 0 2px 4px rgba(209, 230, 220, 1)
  transition 0.2s
</style>
